import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomiSection } from './components/TomiSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const metaWindow = window as Window & {
        fbq?: PixelFunction;
        _fbq?: PixelFunction;
      };
      if (!metaWindow.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) {
            pixel.callMethod(...args);
          } else {
            pixel.queue.push(args);
          }
        }) as PixelFunction;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        metaWindow.fbq = pixel;
        metaWindow._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      metaWindow.fbq?.('init', '836709369446871');
      metaWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nw2ci75e7srm">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=836709369446871&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="nuhh6fb985sp" />
      </noscript>
      <main className="min-h-screen w-full overflow-x-hidden bg-brand-frost" data-id="element-2" data-mp="34x31kk3tf4y">
        <div className="mx-auto w-full max-w-3xl bg-white shadow-2xl" data-id="element-3" data-mp="3ubrhck3tkg3z">
          <UrgencyBanner data-id="element-4" data-mp="d4e94339pv1g" />
          <Hero data-id="element-5" data-mp="d3mmhhrnf7nb" />
          <PainSection data-id="element-6" data-mp="d45ti3frgbmk" />
          <TomiSection data-id="element-7" data-mp="d2biphy7dzw7" />
          <BonusSection data-id="element-8" data-mp="85ukfuxai55e" />
          <PricingCard data-id="element-9" data-mp="86mgt7ypo6wq" />
          <Guarantee data-id="element-10" data-mp="86cnpbiddjmt" />
          <Testimonials data-id="element-11" data-mp="83qihiiybg7r" />
          <FAQ data-id="element-12" data-mp="3gkv0trn63pda" />
          <FinalCTA data-id="element-13" data-mp="3gkl6xsz04y2b" />
          <Footer data-id="element-14" data-mp="3glwc9x83idvj" />
        </div>
      </main>
    </>;
}